// What the Design Assistant accepts as a picture. Mirrors the server's own rule
// (pyapi/app/services/export_design/attachment_service.py `_classify_kind`: an allow-listed content
// type OR a png/jpg/jpeg/webp extension), so the box refuses at once what the server would refuse
// at send time. The check used to be `type.startsWith('image/')`, which let a HEIC, GIF or TIFF
// into the box, where it only failed on Send (with a toast) and then stayed stuck there.
const SUPPORTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
const SUPPORTED_IMAGE_EXTENSION = /\.(png|jpe?g|webp)$/i;

export const isSupportedImageFile = (file: { name: string; type: string }): boolean =>
  SUPPORTED_IMAGE_TYPES.includes((file.type || '').toLowerCase()) ||
  SUPPORTED_IMAGE_EXTENSION.test(file.name || '');
